import { FileTypes } from '@shared/interfaces';

/**
 * File type map used to map file types to their respective categories
 *
 * @remarks
 * Currents supported types images | videos
 *
 * Add your file types here
 */
export const FILETYPE_MAP: Record<FileTypes, string[]> = {
    images: ['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/svg+xml'],
    videos: ['video/mp4', 'video/mpeg', 'video/webm', 'video/quicktime', 'video/x-msvideo'],
    feeds: ['feeds'],
};
